import { FC } from 'react';

import type { MultipleSelectInputProps } from '@types';
import { cn } from '@utils';

import { BaseMultipleSelectInput } from '.';

export const FilledMultipleSelectInput: FC<MultipleSelectInputProps> = ({ className, ...props }) => {
  return <BaseMultipleSelectInput className={cn('px-3 peer outline-none', className)} {...props} />;
};
